export const MEETING_STATUS_OPTIONS = [
  { value: 'draft', label: 'پیش‌نویس', color: 'gold' },
  { value: 'scheduled', label: 'برنامه‌ریزی‌شده', color: 'blue' },
  { value: 'starting_soon', label: 'در آستانه شروع', color: 'cyan' },
  { value: 'live', label: 'در حال برگزاری', color: 'green' },
  { value: 'finished', label: 'پایان‌یافته', color: 'default' },
  { value: 'not_held', label: 'برگزارنشده', color: 'orange' },
  { value: 'canceled', label: 'لغوشده', color: 'red' },
];

export const MEETING_STATUS_ADMIN_EXTRA_OPTIONS = [
  { value: 'processing', label: 'در حال پردازش', color: 'purple' },
  { value: 'output_ready', label: 'خروجی آماده', color: 'geekblue' },
  { value: 'hold_error', label: 'خطای برگزاری', color: 'magenta' },
];

export function meetingStatusFilterOptions(includeAdminStatuses = false) {
  if (!includeAdminStatuses) return MEETING_STATUS_OPTIONS;
  const inserted = [...MEETING_STATUS_OPTIONS];
  const finishedIdx = inserted.findIndex((o) => o.value === 'finished');
  inserted.splice(finishedIdx + 1, 0, ...MEETING_STATUS_ADMIN_EXTRA_OPTIONS);
  return inserted;
}

/** برچسب و رنگ وضعیت نمایشی (API: display_status) */
export const MEETING_DISPLAY_STATUS_META = {
  draft: { label: 'پیش‌نویس', color: 'gold' },
  scheduled: { label: 'برنامه‌ریزی‌شده', color: 'blue' },
  starting_soon: { label: 'در آستانه شروع', color: 'cyan' },
  ready_to_join: { label: 'در آستانه شروع', color: 'cyan' },
  live: { label: 'در حال برگزاری', color: 'green' },
  ongoing: { label: 'در حال برگزاری', color: 'green' },
  finished: { label: 'پایان‌یافته', color: 'default' },
  processing: { label: 'در حال پردازش', color: 'purple' },
  output_ready: { label: 'خروجی آماده', color: 'geekblue' },
  not_held: { label: 'برگزارنشده', color: 'orange' },
  hold_error: { label: 'خطای برگزاری', color: 'magenta' },
  canceled: { label: 'لغوشده', color: 'red' },
};

export function normalizeMeetingDisplayStatusKey(key) {
  if (key === 'ready_to_join') return 'starting_soon';
  if (key === 'ongoing') return 'live';
  return key;
}

export const MEETING_TYPE_OPTIONS = [
  { value: 'online', label: 'آنلاین' },
  { value: 'physical', label: 'حضوری' },
  { value: 'hybrid', label: 'ترکیبی' },
];

export const MEETING_TYPE_CHIP_TONE = {
  online: 'sky',
  physical: 'teal',
  hybrid: 'violet',
};

export const MEETING_MODE_OPTIONS = [
  { value: 'public', label: 'با لینک جلسه' },
  { value: 'private', label: 'فقط اعضای سازمان' },
  { value: 'confidential', label: 'فقط دعوت‌شده‌ها' },
];

/** راهنمای سطح دسترسی جلسه */
export const MEETING_MODE_GUIDE = [
  {
    value: 'public',
    label: 'با لینک جلسه',
    hint: 'هر فرد دارای لینک می‌تواند درخواست ورود دهد؛ پیش‌فرض جلسات جدید.',
  },
  {
    value: 'private',
    label: 'فقط اعضای سازمان',
    hint: 'ورود برای کاربران عضو سازمان.',
  },
  {
    value: 'confidential',
    label: 'فقط دعوت‌شده‌ها',
    hint: 'فقط میزبان، میزبان‌های همکار و فهرست مشخص شرکت‌کنندگان می‌توانند وارد شوند.',
  },
];

export const MEETING_CONFIDENTIALITY_OPTIONS = [
  { value: 'public', label: 'عمومی' },
  { value: 'internal', label: 'داخلی سازمان' },
  { value: 'confidential', label: 'محرمانه' },
  { value: 'secret', label: 'بسیار محرمانه' },
];

/** راهنمای سطح محرمانگی */
export const MEETING_CONFIDENTIALITY_GUIDE = [
  {
    value: 'public',
    label: 'عمومی',
    hint: 'اطلاعات جلسه برای همه اعضای سازمان قابل مشاهده است؛ پیش‌فرض جلسات جدید.',
  },
  {
    value: 'internal',
    label: 'داخلی سازمان',
    hint: 'فقط برای اعضای داخلی سازمان.',
  },
  {
    value: 'confidential',
    label: 'محرمانه',
    hint: 'دسترسی محدود؛ مناسب جلسات مدیریتی و حساس.',
  },
  {
    value: 'secret',
    label: 'بسیار محرمانه',
    hint: 'بالاترین سطح محرمانگی؛ فقط افراد مجاز.',
  },
];

export const PARTICIPANT_ROLE_OPTIONS = [
  { value: 'host', label: 'میزبان' },
  { value: 'cohost', label: 'میزبان همکار' },
  { value: 'mandatory', label: 'شرکت‌کننده اجباری' },
  { value: 'optional', label: 'شرکت‌کننده اختیاری' },
  { value: 'viewer', label: 'مشاهده‌گر' },
];

/** نقش‌های مجاز بر اساس نوع جلسه */
const MEETING_TYPE_ROLE_SETS = {
  online: [
    { value: 'host', label: 'ارائه‌دهنده', hint: 'مدیریت جلسه آنلاین و دسترسی ارائه.' },
    { value: 'viewer', label: 'مشاهده‌گر', hint: 'فقط مشاهده جلسه آنلاین بدون دسترسی مدیریتی.' },
  ],
  physical: [
    { value: 'host', label: 'میزبان', hint: 'مسئول اصلی برگزاری جلسه حضوری.' },
    { value: 'mandatory', label: 'شرکت‌کننده اجباری', hint: 'حضور در جلسه الزامی است.' },
    { value: 'optional', label: 'شرکت‌کننده اختیاری', hint: 'دعوت‌شده اما حضور اجباری نیست.' },
  ],
  hybrid: [
    { value: 'host', label: 'ارائه‌دهنده', hint: 'مدیریت بخش آنلاین و هماهنگی جلسه.' },
    { value: 'viewer', label: 'مشاهده‌گر', hint: 'فقط مشاهده بخش آنلاین جلسه.' },
    { value: 'mandatory', label: 'حضوری اجباری', hint: 'حضور فیزیکی در جلسه الزامی است.' },
    { value: 'optional', label: 'حضوری اختیاری', hint: 'حضور فیزیکی اختیاری است.' },
  ],
};

export function getParticipantRoleOptions(meetingType) {
  return MEETING_TYPE_ROLE_SETS[meetingType] || MEETING_TYPE_ROLE_SETS.online;
}

export function getDefaultParticipantRole(meetingType) {
  const opts = getParticipantRoleOptions(meetingType);
  return opts.find((o) => o.value === 'viewer')?.value
    || opts.find((o) => o.value === 'mandatory')?.value
    || opts[0]?.value
    || 'mandatory';
}

export function normalizeParticipantRoleForMeetingType(role, meetingType) {
  const allowed = getParticipantRoleOptions(meetingType).map((o) => o.value);
  if (allowed.includes(role)) return role;
  return getDefaultParticipantRole(meetingType);
}

const ADD_SOURCE_LABELS = {
  manual: 'دستی',
  room: 'اتاق',
  department: 'دپارتمان',
  excel: 'فایل اکسل',
};

export function formatParticipantAddSource(source, label) {
  if (!source || source === 'manual') return ADD_SOURCE_LABELS.manual;
  const prefix = ADD_SOURCE_LABELS[source] || source;
  return label ? `${prefix}: ${label}` : prefix;
}

/** راهنمای نقش شرکت‌کنندگان */
export const PARTICIPANT_ROLE_GUIDE = [
  {
    value: 'host',
    label: 'میزبان',
    hint: 'مسئول اصلی برگزاری جلسه. می‌تواند جلسه آنلاین را شروع کند، ضبط را مدیریت کند و تا ۳۰ دقیقه قبل از شروع وارد شود. معمولاً یک نفر.',
  },
  {
    value: 'cohost',
    label: 'میزبان همکار',
    hint: 'دسترسی مدیریتی نزدیک به میزبان برای پشتیبانی از برگزاری (مثلاً مدیریت شرکت‌کنندگان یا اشتراک صفحه). می‌تواند زودتر از ساعت شروع وارد شود.',
  },
  {
    value: 'mandatory',
    label: 'شرکت‌کننده اجباری',
    hint: 'حضور این فرد در جلسه الزامی است و در گزارش حضور و غیاب لحاظ می‌شود. دعوت‌نامه و یادآوری برای او ارسال می‌شود.',
  },
  {
    value: 'optional',
    label: 'شرکت‌کننده اختیاری',
    hint: 'به جلسه دعوت شده اما حضور اجباری نیست. در صورت عدم حضور، جلسه لغو یا به تعویق نمی‌افتد.',
  },
  {
    value: 'viewer',
    label: 'مشاهده‌گر',
    hint: 'فقط حق مشاهده جلسه را دارد و نمی‌تواند جلسه را مدیریت کند. مناسب ناظران، گزارش‌گیرندگان یا اعضایی که فقط باید محتوا را ببینند.',
  },
];

export const PARTICIPANT_STATUS_OPTIONS = [
  { value: 'invited', label: 'دعوت‌شده', color: 'blue' },
  { value: 'accepted', label: 'پذیرفته', color: 'green' },
  { value: 'maybe', label: 'شاید', color: 'gold' },
  { value: 'declined', label: 'رد کرده', color: 'red' },
  { value: 'joined', label: 'وارد شده', color: 'purple' },
  { value: 'no_show', label: 'غایب', color: 'orange' },
  { value: 'left', label: 'خارج شده', color: 'default' },
  { value: 'pending', label: 'در انتظار', color: 'blue' },
];

export const RECURRENCE_TYPE_OPTIONS = [
  { value: 'daily', label: 'روزانه' },
  { value: 'weekly', label: 'هفتگی' },
  { value: 'monthly', label: 'ماهانه' },
];

export const WEEKDAY_OPTIONS = [
  { value: 6, label: 'شنبه' },
  { value: 0, label: 'یکشنبه' },
  { value: 1, label: 'دوشنبه' },
  { value: 2, label: 'سه‌شنبه' },
  { value: 3, label: 'چهارشنبه' },
  { value: 4, label: 'پنجشنبه' },
  { value: 5, label: 'جمعه' },
];

export const TIMEZONE_OPTIONS = [
  { value: 'Asia/Tehran', label: 'تهران' },
  { value: 'Asia/Dubai', label: 'دبی' },
  { value: 'Europe/Berlin', label: 'برلین' },
  { value: 'UTC', label: 'گرینویچ' },
];

export const DEFAULT_MEETING_MODE = 'public';
export const DEFAULT_MEETING_CONFIDENTIALITY = 'public';

/** پیش‌فرض‌های تنظیمات BBB برای فرم ایجاد جلسه آنلاین — هم‌تراز سطح محرمانگی عمومی */
export const DEFAULT_BBB_SETTINGS = {
  guestPolicy: 'ALWAYS_ACCEPT',
  requireModeratorJoin: false,
  allowStartStopRecording: true,
  muteOnStart: true,
  allowModsToEjectCameras: true,
  allowModsToUnmuteUsers: true,
  endWhenNoModeratorDelayInMinutes: 10,
  bannerColor: '#14A196',
};

/** برچسب فارسی مقادیر enum تنظیمات جلسه آنلاین */
export const BBB_ENUM_LABELS = {
  ALWAYS_ACCEPT: 'همیشه پذیرفته شود',
  ALWAYS_DENY: 'همیشه رد شود',
  ASK_MODERATOR: 'نیاز به تأیید میزبان',
  SMART_LAYOUT: 'چیدمان هوشمند',
  CUSTOM_LAYOUT: 'چیدمان سفارشی',
  PRESENTATION_FOCUS: 'تمرکز ارائه',
  VIDEO_FOCUS: 'تمرکز ویدیو',
};

/** برچسب فارسی کلیدهای تنظیمات جلسه آنلاین (وقتی API برچسب نفرستد) */
export const BBB_FIELD_LABELS = {
  muteOnStart: 'بی‌صدای اولیه',
  guestPolicy: 'سیاست ورود مهمان',
  maxParticipants: 'حداکثر شرکت‌کننده',
  record: 'فعال‌سازی ضبط',
  autoStartRecording: 'شروع خودکار ضبط',
  lockSettingsDisableCam: 'غیرفعال کردن دوربین',
  lockSettingsDisableMic: 'غیرفعال کردن میکروفون',
  welcomeMessage: 'پیام خوش‌آمدگویی',
  meetingLayout: 'چیدمان صفحه',
};

export const BBB_GROUP_LABELS = {
  access: 'ورود و دسترسی',
  recording: 'ضبط جلسه',
  lock_settings: 'تنظیمات قفل',
  appearance: 'ظاهر و نمایش',
  management: 'مدیریت جلسه',
  other: 'سایر',
};

/** نگاشت مقدار خام API به برچسب فارسی (وقتی در options نیست) */
const RAW_VALUE_LABELS = {
  online: 'آنلاین',
  physical: 'حضوری',
  hybrid: 'ترکیبی',
  draft: 'پیش‌نویس',
  scheduled: 'برنامه‌ریزی‌شده',
  ready_to_join: 'در آستانه شروع',
  starting_soon: 'در آستانه شروع',
  live: 'در حال برگزاری',
  ongoing: 'در حال برگزاری',
  finished: 'پایان‌یافته',
  processing: 'در حال پردازش',
  output_ready: 'خروجی آماده',
  not_held: 'برگزارنشده',
  hold_error: 'خطای برگزاری',
  canceled: 'لغوشده',
  public: 'عمومی',
  private: 'فقط اعضای سازمان',
  confidential: 'محرمانه',
  secret: 'بسیار محرمانه',
  internal: 'داخلی سازمان',
  host: 'میزبان',
  cohost: 'میزبان همکار',
  mandatory: 'اجباری',
  optional: 'اختیاری',
  viewer: 'مشاهده‌گر',
  daily: 'روزانه',
  weekly: 'هفتگی',
  monthly: 'ماهانه',
  ...BBB_ENUM_LABELS,
};

export function translateRawValue(value, fallback = '—') {
  if (value == null || value === '') return fallback;
  const key = String(value);
  return RAW_VALUE_LABELS[key] || BBB_ENUM_LABELS[key] || key;
}

export function optionLabel(options, value, fallback = '—') {
  if (value == null || value === '') return fallback;
  const found = options.find((o) => String(o.value) === String(value));
  if (found) return found.label;
  return translateRawValue(value, fallback);
}

/** زیرعنوان فشرده برای لیست جلسات */
export function meetingListSubtitle(meeting) {
  if (!meeting || typeof meeting !== 'object') return '';
  const parts = [];
  if (meeting.host?.name || meeting.host?.email) {
    parts.push(meeting.host?.name || meeting.host?.email);
  }
  if (meeting.room?.name) parts.push(meeting.room.name);
  if (meeting.objective) parts.push(meeting.objective);
  return parts.join(' · ');
}

/** برچسب حالت دسترسی جلسه (mode) */
export function meetingModeLabel(meeting) {
  return optionLabel(MEETING_MODE_OPTIONS, meeting?.mode, '—');
}

/** خلاصه تکرار جلسه */
export function meetingRecurrenceSummary(meeting) {
  if (!meeting?.is_recurring) return null;
  const type = optionLabel(RECURRENCE_TYPE_OPTIONS, meeting.recurrence_type);
  const parts = [type];
  if (meeting.recurrence_interval > 1) {
    parts.push(`هر ${meeting.recurrence_interval}`);
  }
  if (Array.isArray(meeting.recurrence_days) && meeting.recurrence_days.length) {
    const days = meeting.recurrence_days
      .map((d) => optionLabel(WEEKDAY_OPTIONS, d))
      .filter((l) => l && l !== '—')
      .join('، ');
    if (days) parts.push(days);
  }
  if (meeting.recurrence_count) parts.push(`${meeting.recurrence_count} بار`);
  return parts.join(' · ');
}

/** برچسب‌های ویژگی برای نمایش در ایندکس */
export function meetingFeatureTags(meeting) {
  if (!meeting || typeof meeting !== 'object') return [];
  const tags = [];
  if (meeting.record) tags.push({ key: 'record', label: 'ضبط', color: 'purple' });
  if (meeting.autoStartRecording) tags.push({ key: 'auto-rec', label: 'ضبط خودکار', color: 'geekblue' });
  if (meeting.is_recurring) tags.push({ key: 'recurring', label: 'تکراری', color: 'cyan' });
  if (meeting.allow_guest) tags.push({ key: 'guest', label: 'مهمان', color: 'blue' });
  return tags;
}

export function optionColor(options, value) {
  return options.find((o) => String(o.value) === String(value))?.color;
}

export function formatApiDateTime(value, fallback = '—') {
  if (!value) return fallback;
  if (typeof value === 'object') {
    return value.jalali || value.iso || fallback;
  }
  return String(value);
}

export function apiDateToInputValue(value) {
  if (!value) return undefined;
  if (typeof value === 'object') return value.jalali || value.iso || undefined;
  return value;
}

function boolish(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

function parseMeetingTimestamp(value) {
  if (!value) return null;
  if (typeof value === 'object') {
    if (typeof value.timestamp === 'number') return value.timestamp * 1000;
    const raw = value.iso || value.gregorian || value.value || value.jalali;
    if (!raw) return null;
    const ms = Date.parse(String(raw).replace(/\//g, '-'));
    return Number.isNaN(ms) ? null : ms;
  }
  const ms = Date.parse(String(value).replace(/\//g, '-'));
  return Number.isNaN(ms) ? null : ms;
}

/** محاسبه fallback وضعیت نمایشی وقتی API فیلد display_status نفرستاده */
function computeMeetingStatusMeta(meeting) {
  const status = meeting?.status;
  const active = boolish(meeting?.bbb_session_active);
  const isOnline = meeting?.type === 'online';
  const now = Date.now();
  const startsAt = parseMeetingTimestamp(meeting?.starts_at);
  const endsAt = parseMeetingTimestamp(meeting?.ends_at);
  const recordingSync = meeting?.recording_sync_status;
  const hasStartError = Boolean(meeting?.bbb_start_error);
  const wasHeld = status === 'ongoing'
    || active
    || Boolean(meeting?.bbb_started_at)
    || Boolean(meeting?.session_held)
    || ['finished', 'processing', 'output_ready'].includes(meeting?.display_status);

  if (status === 'draft') return { ...MEETING_DISPLAY_STATUS_META.draft, key: 'draft' };
  if (status === 'canceled') return { ...MEETING_DISPLAY_STATUS_META.canceled, key: 'canceled' };
  if (endsAt != null && now > endsAt) {
    if (isOnline && !wasHeld) {
      if (hasStartError) return { ...MEETING_DISPLAY_STATUS_META.hold_error, key: 'hold_error' };
      return { ...MEETING_DISPLAY_STATUS_META.not_held, key: 'not_held' };
    }
    if (recordingSync === 'pending') return { ...MEETING_DISPLAY_STATUS_META.processing, key: 'processing' };
    if (recordingSync === 'ready') return { ...MEETING_DISPLAY_STATUS_META.output_ready, key: 'output_ready' };
    return { ...MEETING_DISPLAY_STATUS_META.finished, key: 'finished' };
  }
  if (status === 'finished' && (endsAt == null || now > endsAt)) {
    return { ...MEETING_DISPLAY_STATUS_META.finished, key: 'finished' };
  }

  if (startsAt != null && endsAt != null) {
    if (now < startsAt) {
      return { ...MEETING_DISPLAY_STATUS_META.scheduled, key: 'scheduled' };
    }
    if (now <= endsAt) {
      if (isOnline) {
        if (status === 'ongoing' || active) {
          return { ...MEETING_DISPLAY_STATUS_META.live, key: 'live' };
        }
        return { ...MEETING_DISPLAY_STATUS_META.starting_soon, key: 'starting_soon' };
      }
      return { ...MEETING_DISPLAY_STATUS_META.live, key: 'live' };
    }
  }

  if (status === 'ongoing' && active) {
    return { ...MEETING_DISPLAY_STATUS_META.live, key: 'live' };
  }
  if (status === 'scheduled' && isOnline && active) {
    return { ...MEETING_DISPLAY_STATUS_META.live, key: 'live' };
  }
  if (status === 'scheduled' && isOnline) {
    return { ...MEETING_DISPLAY_STATUS_META.starting_soon, key: 'starting_soon' };
  }

  return {
    key: status || 'scheduled',
    label: optionLabel(MEETING_STATUS_OPTIONS, status),
    color: optionColor(MEETING_STATUS_OPTIONS, status) || 'default',
  };
}

const ENDED_DISPLAY_STATUSES = new Set([
  'finished',
  'not_held',
  'hold_error',
  'processing',
  'output_ready',
  'canceled',
  'draft',
]);
const ENDED_STATUSES = new Set(['finished', 'canceled', 'draft']);

export function meetingStatusMeta(meetingOrStatus, activeMaybe) {
  if (typeof meetingOrStatus === 'object' && meetingOrStatus) {
    const computed = computeMeetingStatusMeta(meetingOrStatus);
    const endsAt = parseMeetingTimestamp(meetingOrStatus.ends_at);
    const displayKey = normalizeMeetingDisplayStatusKey(meetingOrStatus.display_status);
    const apiEnded = ENDED_DISPLAY_STATUSES.has(displayKey);
    if (endsAt != null && Date.now() > endsAt) {
      const held = Boolean(meetingOrStatus.session_held)
        || Boolean(meetingOrStatus.bbb_started_at)
        || meetingOrStatus.status === 'ongoing'
        || boolish(meetingOrStatus.bbb_session_active)
        || ['finished', 'processing', 'output_ready'].includes(displayKey);
      if (held) {
        if (displayKey && ['finished', 'processing', 'output_ready'].includes(displayKey)
          && MEETING_DISPLAY_STATUS_META[displayKey]) {
          return {
            key: displayKey,
            label: meetingOrStatus.display_status_label || MEETING_DISPLAY_STATUS_META[displayKey].label,
            color: MEETING_DISPLAY_STATUS_META[displayKey].color,
          };
        }
        return computed;
      }
      if (apiEnded && MEETING_DISPLAY_STATUS_META[displayKey]) {
        return {
          key: displayKey,
          label: meetingOrStatus.display_status_label || MEETING_DISPLAY_STATUS_META[displayKey].label,
          color: MEETING_DISPLAY_STATUS_META[displayKey].color,
        };
      }
      return computed;
    }
    if (displayKey && MEETING_DISPLAY_STATUS_META[displayKey]) {
      return {
        key: displayKey,
        label: meetingOrStatus.display_status_label || MEETING_DISPLAY_STATUS_META[displayKey].label,
        color: MEETING_DISPLAY_STATUS_META[displayKey].color,
      };
    }
    return computed;
  }

  const status = normalizeMeetingDisplayStatusKey(meetingOrStatus);
  const active = boolish(activeMaybe);

  if (status === 'live' && active) {
    return { key: 'live', ...MEETING_DISPLAY_STATUS_META.live };
  }
  if (status === 'scheduled') {
    return active
      ? { key: 'live', ...MEETING_DISPLAY_STATUS_META.live }
      : { key: 'scheduled', ...MEETING_DISPLAY_STATUS_META.scheduled };
  }
  if (MEETING_DISPLAY_STATUS_META[status]) {
    return { key: status, ...MEETING_DISPLAY_STATUS_META[status] };
  }

  return {
    key: status,
    label: optionLabel(MEETING_STATUS_OPTIONS, status),
    color: optionColor(MEETING_STATUS_OPTIONS, status),
  };
}

/**
 * بستن جلسه فقط وقتی اتاق BBB باز و جلسه در حال برگزاری است.
 * جلسات برگزارشده / لغوشده / آمادهٔ ورودِ بدون نشست فعال این دکمه را نمی‌بینند.
 */
export function canShowMeetingCloseAction(meeting) {
  if (!meeting) return false;
  if (ENDED_STATUSES.has(meeting.status) || ENDED_DISPLAY_STATUSES.has(meeting.display_status)) {
    return false;
  }
  return meeting.status === 'ongoing'
    || meeting.display_status === 'live'
    || boolish(meeting.bbb_session_active);
}

/**
 * لغو فقط برای جلسه‌ای که هنوز برگزار نشده و زمانش تمام نشده.
 * جلسهٔ زنده دکمهٔ بستن دارد، نه لغو.
 */
export function canShowMeetingCancelAction(meeting, nowMs = Date.now()) {
  if (!meeting) return false;
  if (ENDED_STATUSES.has(meeting.status) || ENDED_DISPLAY_STATUSES.has(meeting.display_status)) {
    return false;
  }
  if (canShowMeetingCloseAction(meeting)) return false;
  const endsAt = parseMeetingTimestamp(meeting.ends_at);
  if (endsAt != null && nowMs > endsAt) return false;
  return true;
}

export function formatBbbTimestamp(value, fallback = '—') {
  if (value == null || value === '') return fallback;
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  const ms = n < 1_000_000_000_000 ? n * 1000 : n;
  try {
    return new Date(ms).toLocaleString('fa-IR');
  } catch {
    return String(value);
  }
}
